// removed by extract-text-webpack-plugin
module.exports = {"row":"_3p_s2m8R1iEU_pnR8l2D9X","townName":"_3S3vTdKblw8OC02hMKobY-","papers":"_17ToCL7EPMRrz0VV-IBoJz","stage":"_34RtKjktT6S0dk-pONfAuV","startMarking":"_1cCOZJk7Hc-T73IvCN-3Mk"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/BatchList/BatchesList.css
// module id = 759
// module chunks = 3